"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_LEVEL = exports.NUM_FACES = void 0;
/** Number of cube faces */
exports.NUM_FACES = 6;
/** Valid levels: 0..MAX_LEVEL */
exports.MAX_LEVEL = 30;
